import CityServicePage from "@/pages/city-service/CityServicePage";
import { torontoAcRepair } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={torontoAcRepair} />; }
